import { useAuth0 } from '@auth0/auth0-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const BaseLanding: FC = () => {
  const { t } = useTranslation('ALL');

  const { loginWithRedirect } = useAuth0();

  const onLoginButtonClicked = () => {
    loginWithRedirect();
  };

  return (
    <div className='flex h-screen w-screen flex-wrap content-center bg-blue-700'>
      <div className='mx-auto max-w-2xl px-4 py-16 text-center sm:px-6 sm:py-20 lg:px-8'>
        <div className='mb-10 flex shrink-0 flex-col items-center justify-center px-4'>
          <img className='h-10 w-auto' src='/assets/sidebar/logo.png' alt='logo' />
          <span className='text-lg text-white-100'>Audiencerate</span>
        </div>
        <h2 className='text-3xl font-extrabold text-white-100 sm:text-4xl'>
          <span className='block'>{t('marketingPlatform')}</span>
        </h2>
        <p className='mt-3 text-lg leading-6 text-blue-100'>{t('whereDataMeetsSecurityAndMarketingMeetsSuccess')}</p>
        <a
          href='#'
          onClick={onLoginButtonClicked}
          className='mt-8 inline-flex w-full items-center justify-center rounded-md border border-transparent bg-white-100 px-5 py-3 text-base font-medium text-blue-600 hover:bg-blue-100 sm:w-auto'
        >
          {t('signIn')}
        </a>
      </div>
    </div>
  );
};
